module.exports = __webpack_public_path__ + "static/media/tt.768a52c8.png";